export type TimerCallback = (...args: unknown[]) => void;

export type TimerProps = {
  timeout?: number;
  callback?: TimerCallback;
  bindingContext?: unknown;
}

export class Timer {

  constructor(props: TimerProps) {
    this.callback = props.callback ?? null;
    this.timeout = props.timeout ?? 0;
    this.bindingContext = props.bindingContext ?? null;
  }

  readonly timeout: number;
  readonly callback: TimerCallback | null = null;
  readonly bindingContext: unknown | null;

  private timerId: ReturnType<typeof setTimeout> | null = null;

  start() {
    this.cancel();
    this.timerId = setTimeout(() => {
      this.invoke();
    }, this.timeout);
  }

  cancel() {
    const timerId = this.timerId;
    if (timerId) {
      clearTimeout(timerId);
      this.timerId = null;
    }
  }

  private invoke() {
    this.callback?.call(this.bindingContext ?? this);
  }
}